import { useQuery } from '@apollo/client/react/hooks';
import { GTMPageData } from '../../helpers/analytics/gtm/gtm-types';
import { useCustomer } from '../apollo/customer/customer.hooks';
import { useEmployee } from '../apollo/employee/employee.hooks';
import { PageWindowDataQuery } from '../../__generated__/graphql-client-types';
import { PAGE_WINDOW_DATA } from '../../queries/analytics/device.queries';
import { isInternalIP } from '../../../utils/string/ip-address';
import { doesWindowExist } from '../../helpers/general-helper/general-helper';

type UsePageDataResult = { pageData?: GTMPageData; isLoading: boolean };

export function usePageData(pageName: string): UsePageDataResult {
	const { loading: customerIsLoading, data: { customer } = {}, isPro } = useCustomer();
	const {
		loading: employeeIsLoading,
		employee: { isAuthenticated: employeeIsAuthenticated }
	} = useEmployee();

	const { loading: deviceIsLoading, data: { device } = {} } = useQuery<PageWindowDataQuery>(PAGE_WINDOW_DATA, {
		fetchPolicy: 'cache-and-network',
		// we only need this data on the client, this prevents an additional render pass
		// during SSR.
		skip: !doesWindowExist()
	});

	const isLoading = customerIsLoading || employeeIsLoading || deviceIsLoading;

	if (isLoading) {
		return { isLoading };
	} else {
		const pageData: GTMPageData = {
			customer: {
				isPro,
				userDBID: customer?.id ?? '0'
			},
			employee: {
				isAuthenticated: employeeIsAuthenticated
			},
			device: {
				isOnInternalNetwork: isInternalIP(device ? device.ip : '')
			},
			page: pageName
		};
		return { isLoading, pageData };
	}
}
